"use client";

import { usePostHog } from "posthog-js/react";

import type { TAllergen } from "@./suf-store";

import { FlowNavigationContext } from "../../../shared/constants";
import { resolveFeatureFlagVariant } from "../featureFlags";

import { useSignupFlowStore } from "./useSignUpFlowStore";

export const useFlowNavigationContext = (): FlowNavigationContext => {
  const posthog = usePostHog();
  const { cats, featureFlags, activeCatCount } = useSignupFlowStore((state) => ({
    cats: state.cats,
    featureFlags: state.featureFlags,
    activeCatCount: state.getActiveCatIds().length,
  }));

  const inABTestGroup = (flag: string): boolean => {
    const flagValue = resolveFeatureFlagVariant(
      flag,
      featureFlags,
      () => posthog?.getFeatureFlag(flag),
      activeCatCount,
    );
    return flagValue === "test";
  };

  const catsAllergies = new Set(
    Object.values(cats).flatMap((cat) => cat.diet?.foodAllergies?.allergens ?? []),
  );

  const hasAnyAllergy = (excludedAllergies: TAllergen[]): boolean =>
    excludedAllergies.some((allergen) => catsAllergies.has(allergen));

  return {
    inABTestGroup,
    hasAnyAllergy,
  };
};
